import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Provider } from "react-redux";
import { store } from './store/store';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import FormularioPrograma from './componentes/Soporte/FormularioPrograma';
import FormularioAdelanto from './componentes/Finanzas/FormularioAdelanto';
import FormCajaChica from './componentes/Finanzas/FormularioCajaChica';
import AgregarPedido from './componentes/Coordinador/AgregarPedido';
import ListaAdelantos from './componentes/Finanzas/ListaAdelantos';
import ListaAdelantosPorPrograma from './componentes/Finanzas/ListaAdelantosPorProgramaFinanzas';
import ListaProgramas from './componentes/Soporte/ListaProgramas';
import ListaPedidos from './componentes/Comunicacion/ListaPedidos';
import DashboardComunicacion from './componentes/Comunicacion/DashboardComunicacion';
import ListaPedidosPorPrograma from './componentes/Comunicacion/Tareas/ListaPedidosPorPrograma';
import DashboardCoordinador from './componentes/Coordinador/DashboardCoordinador';
import DashboardSoporte from './componentes/Soporte/DashboardSoporte';
import ListaUsuarios from "./componentes/Soporte/ListaUsuarios";
import FormUsuario from "./componentes/Soporte/FormularioUsuario";
import Login from "./componentes/Usuario/Login";
import DashboardPrograma from"./componentes/Finanzas/DashboardPrograma"
import RecuperarContrasenia from './componentes/Usuario/RecuperarContrasenia';
import DetalleAdelanto from './componentes/Finanzas/detalleAdelanto';
import DetalleGasto from './componentes/Finanzas/detalleGasto';
import DetallePedido from './componentes/Comunicacion/DetallePedido';
import NavBar from './componentes/NavBar';
import SubirArchivo from "./componentes/Archivos/SubirArchivoFinanzas"
import 'react-toastify/dist/ReactToastify.css';
import DashboardFinanzas from './componentes/Finanzas/DashboardFinanzas';
import DashboardAuditoria from './Auditoria/DashboardAuditoria';
import ListaGastos from './componentes/Finanzas/ListaGastoPorPrograma';
import ListadoPedidos from './componentes/Comunicacion/ListaPedidos';
import VerRendicion from './componentes/Archivos/VerRendicion';
import Gastos from './componentes/Finanzas/ListaGastos'
import DashboardGeneral from './componentes/General/DashboardGeneral';
import ChatBot from './chatbot/ChatBot';   
import TemplateDesigner from './scaner/TemplateDesigner';
import EscanerCuestionario from './scaner/ScanTester';
import plantillaCuestionario from './scaner/plantilla.json';
import QrScanner from './scaner/QrScanner';
import RevisionDataEntry from './scaner/Revisiondataentry';
import TransformacionDigital from './TransformacionDigital/DashboardTranformacionDigital';
import PruebaStress from './scaner/pruebaStres';
import GeneradorQRPorCentro from './scaner/GeneradorQRPorCentro';
import NauFormulario from './Externo/NauFest/NauFormulario';
import JuradoExpo from './Eventos/juradosExpo';
import CheckinExpo from './Eventos/checkinExpo';

import Cargamasiva from './componentes/TransformacionDigital/CargadorMasivo';
import TotemEntrada from './Externo/NauFest/totemNau';
function App() {


  //const [notificaciones, setNotificaciones] = useState([]);
  const [chatAbierto, setChatAbierto] = useState(false);


  const abrirChat = () => {
    setChatAbierto(!chatAbierto);
};

  return (
    <Provider store={store}>
      <ToastContainer />
      
      <Router>
        <div>
           <NavBar/>   
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path='/DashboardGeneral' element={<DashboardGeneral/>}/>
            <Route path="/FormularioAdelanto" element={<FormularioAdelanto />} />
            <Route path="/FormCajaChica" element={<FormCajaChica />} />
            <Route path="/listaProgramas" element={<ListaProgramas />} />
            <Route path="/FormularioPrograma/:id" element={<FormularioPrograma />} />
            <Route path="/FormularioPrograma" element={<FormularioPrograma />} /> {/* Para nuevo programa */}
            <Route path="/AgregarPedido" element={<AgregarPedido />} />
            <Route path="/adelantos/:idPrograma" element={<ListaAdelantosPorPrograma />} />
            <Route path="/adelantos" element={<ListaAdelantos />} />
            <Route path="/programas" element={<ListaProgramas />} />
            <Route path="/pedidos" element={<ListaPedidos />} />
            <Route path="/DashboardComunicacion" element={<DashboardComunicacion />} />
            <Route path="/listaPedidosPorPrograma/:id" element={<ListaPedidosPorPrograma />} />
            <Route path='/ListaUsuarios' element={<ListaUsuarios />} />
            <Route path="/DashboardCoordinador" element={<DashboardGeneral  />} />
            <Route path="/DashboardSoporte" element={<DashboardSoporte abrirChat={abrirChat} />} />
            <Route path="/FormUsuario" element={<FormUsuario />} />
            <Route path="/RecuperarContrasenia" element={<RecuperarContrasenia />} />
            <Route path="/DashboardFinanzas" element={<DashboardFinanzas />} />
            <Route path="/DashboardPrograma/:id" element={<DashboardPrograma />} />
            <Route path="/archivo" element={<SubirArchivo/>}/>
            <Route path="/adelanto/:id" element={<DetalleAdelanto/>} />
            <Route path="/pedido/:id" element={<DetallePedido/>} />
            <Route path="/gasto/:id" element={<DetalleGasto/>} />
            <Route path="/ListadoPedidos" element={<ListadoPedidos/>} />
            <Route path="/verRendicion/:id" element={<VerRendicion/>} />
            <Route path="/DashboardAuditoria" element={<DashboardAuditoria />} />
            <Route path="/listadoGastosPorPrograma/:idPrograma" element={<ListaGastos/>} />
            <Route path="/gastos" element={<Gastos/>} />
            <Route path="/chatbot/:programa/:tipo" element={<ChatBot />} />
            <Route path="/template-designer" element={<TemplateDesigner />} />
            <Route path="/naufest" element={<NauFormulario />} />
            <Route path="/juradoExpo" element={<JuradoExpo />} />
            <Route path="/checkinExpo" element={<CheckinExpo />} />
            <Route path="/escaner-cuestionario" element={
  <EscanerCuestionario
  baseApi="http://0.0.0.0:5132"
  plantilla={plantillaCuestionario}
  totalPaginas={plantillaCuestionario.paginas.length}
  proxyUrl="http://0.0.0.0:5132/api/FormAssemblyProxy/submit"
/>
} />
            <Route path="/qr-scanner" element={<QrScanner />} />
            <Route path="/revision-data-entry" element={<RevisionDataEntry />} />
            <Route path="/dashboard-transformacion-digital" element={<TransformacionDigital />} />
            <Route path="/prueba-stress" element={<PruebaStress />} />
            <Route path="/qrporcentro" element={<GeneradorQRPorCentro />} />
            <Route path="/cargamasiva" element={<Cargamasiva />} />
            <Route path="/totemNau" element={<TotemEntrada />} />

          </Routes>

          
            {/* notificaciones.map((notificacion, index) => (
             <div key={index}>
             {notificacion.msg} {Mostrar el mensaje }
             </div>
        ))*/}      

          
        </div>
      </Router>
      
    </Provider>
  );
}

export default App;
